'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = { version: '3.0.0-alpha.18' };

exports['default'] = _package.version;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_antd@3.0.0-alpha.18@antd/lib/version/index.js
// module id = 550
// module chunks = 0